import React from "react";
import Select from "react-select";
import Helpers from "../../../helper/helper";
import LightbarDrawing from "./LightbarDrawing";
import { CUSTOM_OPTION, LIGHTBAR_LIGHTHEAD_MODAL_TITLE } from "../../../services/Constant";

const LightBarPreviewComponent = ({
  lightData,
  closeLightbarPreviewModel,
  tooltipData,
  currentZoneData,
  setLightbarLightheadsCallingBlocking,
}) => {
  const FindSelectedIndex = (options, value) => options.findIndex((x) => x.value === value);
  const colorMap = [...(currentZoneData?.lightheads || [])]
    .sort((a, b) => {
      if (a.lightheadPosition == null) return 0;
      if (b.lightheadPosition == null) return 0;

      return a.lightheadPosition - b.lightheadPosition;
    })
    .reduce(
      (acc, lighthead, i) => ({
        ...acc,
        [i]: Object.keys(lighthead.color).map((key) => ({
          ...lighthead,
          ...lighthead.color[key],
        })),
      }),
      {}
    );
  const solo = currentZoneData?.lightheads.length === 0;
  return (
    <>
      <div id="previewLightbar-modal" className="m-auto">
        <div className="modal-dialog m-0">
          <div className="modal-content">
            <div className="d-flex align-items-center">
              <h3 className="modal-title text-white mt-0">{LIGHTBAR_LIGHTHEAD_MODAL_TITLE}</h3>
              <div className="close-icon text-end ms-auto">
                <button type="button" className="close" data-dismiss="modal" onClick={closeLightbarPreviewModel}>
                  <span aria-hidden="true">
                    <i className="fa fa-times text-red" />
                  </span>
                </button>
              </div>
            </div>
            <LightbarDrawing lightData={lightData} currentZoneData={currentZoneData} tooltipData={tooltipData} />
            {!solo ? (
              <div className="table-responsive" style={{ height: "calc(100vh - 450px)" }}>
                <table className="table el-header table-bordered align-middle table-dark table-sm-cell">
                  <thead>
                    <tr>
                      {currentZoneData && currentZoneData?.bxrVersion === "2.0" ? <th>Lighthead Position</th> : null}
                      <th>Source</th>
                      <th>Position</th>
                      <th>Calling Intensity</th>
                      <th>Blocking Intensity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(colorMap).map((colorRow, mainIndex) =>
                      colorMap[colorRow].map((row, colorIndex) => (
                        <tr key={`${colorRow}-${row.id + colorIndex}`}>
                          {currentZoneData && currentZoneData?.bxrVersion === "2.0" ? (
                            <td>{colorIndex <= 0 && row?.lightheadPosition ? row.lightheadPosition : null}</td>
                          ) : null}
                          <td>{`${row?.modelNumber} - ${row?.color}`}</td>
                          <td>{row.position}</td>

                          <td style={{ minWidth: "180px" }}>
                            <div className="form-group cursor-pt mb-0">
                              <Select
                                value={
                                  currentZoneData?.intensityOptions[
                                    FindSelectedIndex(currentZoneData?.intensityOptions, row.call_intensity)
                                  ]
                                }
                                options={currentZoneData?.intensityOptions.filter(
                                  (option) => option.value !== CUSTOM_OPTION
                                )}
                                className="select-sdd"
                                isSearchable={false}
                                // menuPortalTarget={document.body}
                                menuPosition="fixed"
                                // styles={Helpers.getDropDownOptionsForPreviewModel()}
                                styles={Helpers.getDropDownStyleZoneRtnAbs()}
                                onChange={(e) => {
                                  setLightbarLightheadsCallingBlocking(
                                    e,
                                    mainIndex,
                                    colorIndex,
                                    row.id,
                                    "call_intensity",
                                    currentZoneData
                                  );
                                }}
                              />
                            </div>
                          </td>
                          <td style={{ minWidth: "180px" }}>
                            <div className="form-group cursor-pt mb-0">
                              <Select
                                value={
                                  currentZoneData?.intensityOptions[
                                    FindSelectedIndex(currentZoneData?.intensityOptions, row.block_intensity)
                                  ]
                                }
                                options={currentZoneData?.intensityOptions.filter(
                                  (option) => option.value !== "Custom"
                                )}
                                className="select-sdd"
                                isSearchable={false}
                                // menuPortalTarget={document.body}
                                menuPosition="fixed"
                                // styles={Helpers.getDropDownOptionsForPreviewModel()}
                                styles={Helpers.getDropDownStyleZoneRtnAbs()}
                                onChange={(e) => {
                                  setLightbarLightheadsCallingBlocking(
                                    e,
                                    mainIndex,
                                    colorIndex,
                                    row.id,
                                    "block_intensity",
                                    currentZoneData
                                  );
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default LightBarPreviewComponent;
